const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1'])

function getRequestOrigin(): string | null {
  if (typeof window === 'undefined') return null

  const { hostname, origin, protocol } = window.location
  if (protocol !== 'http:' && protocol !== 'https:') return null
  if (LOCAL_HOSTNAMES.has(hostname)) return null

  return origin
}

export function getApiBaseUrl(): string {
  return getRequestOrigin() ?? import.meta.env.VITE_API_URL ?? 'http://localhost:8000'
}

export function buildApiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path

  const baseUrl = getApiBaseUrl().replace(/\/+$/, '')
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${baseUrl}${normalizedPath}`
}
